
import API from "@api/index.js";
export default class ServiceList{
    constructor(){
        this._serviceList = [];
        this._selected = [];
        this._parent = null;
        this._infoList = [];
        this._infoCode = '';
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        if(data.length >0 ){      
            let _categoryList =[];
            for(let i = 0; i <data.length; i++) {
                let isFind = false;
                for(let j = 0; j <_categoryList.length; j++) {
                    if(data[i].categorycode == _categoryList[j].categorycode){
                        _categoryList[j].categorycode = data[i].categorycode;
                        _categoryList[j].category = data[i].category;
                        _categoryList[j].serviceGoodsList.push(data[i]);
                        isFind = true;
                    }
                }
                if(!isFind){
                    _categoryList.push({
                        categorycode:data[i].categorycode,
                        category:data[i].category,
                        serviceGoodsList:[data[i]]
                    })
                }
            }   
            // console.log('_categoryList',this._serviceList);

            this._serviceList = _categoryList;

        }
    } 
    initInfo(code) {        
        // if(data[i].categorycode == this._infoCode) {
        //     // 如果code相等的话,就将categoryList里面添加一个字段
        //     _categoryList[j].infoList = this._infoList[0];
        // }
        for(var k = 0; k < this._serviceList.length; k++) {
            for(var i = 0; i < this._serviceList[k].serviceGoodsList.length; i++) {
                if(this._serviceList[k].serviceGoodsList[i].code == code) {
                    this._serviceList[k].serviceGoodsList[i]._infoList = this._infoList[0];
                }
            }
        }
    }   

      // 获取服务商品列表
      getServiceListInfo(code){
        let _params = {            
            code: code
        };
        // 每次请求之间清空数组
        this._infoList = [];
        return new Promise((reslove,reject)=>{
            API.getServiceListInfo(_params).then(x=>{
                if(x.code == 0) {
                    this._infoList.push(x.t);  
                }
                reslove(x)             
            }).catch(err=>{
                reject(`获取服务说明列表出错:${JSON.stringify(_params)}`)
            })
        })
    }
}